<div class="coin-icon-container" [style.background-color]="account.color" [class]="size">
  <div class="coin-icon" [innerHTML]="account.icon | safe"></div>
  <div *ngIf="isNetworkIconShown" class="coin-network" [innerHTML]="getNetworkIcon() | safe"></div>
</div>
